import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BiResponseDto } from "../../shared/dtos/bi/BiResponseDto";

export interface BiState {
  insights: BiResponseDto["insights"] | null;
  loadingInsights: boolean;
  errorLoadingInsights: string | null;
}

const initialState: BiState = {
  insights: null,
  loadingInsights: false,
  errorLoadingInsights: null,
};

export const biSlice = createSlice({
  name: "bi",
  initialState,
  reducers: {
    setLoadingInsights(state) {
      state.loadingInsights = true;
      state.errorLoadingInsights = null;
    },
    setInsights(state, action: PayloadAction<BiResponseDto["insights"]>) {
      state.loadingInsights = false;
      state.insights = action.payload;
      state.errorLoadingInsights = null;
    },
    setErrorLoadingInsights(state, action: PayloadAction<string | null>) {
      state.loadingInsights = false;
      state.errorLoadingInsights = action.payload;
    },
  },
});

export const biActions = biSlice.actions;
export default biSlice.reducer;
